import { v4 as uuidv4 } from "uuid";
import { getWindow } from "../window";

/**
 * Copy paste from hotpotato
 * https://github.com/expensecheck/hotpotato/tree/develop/src/utilities/xdm
 */

export const POLL_INTERVAL_MS = 1000;
export const POLL_TIMEOUT_MS = 10000;

export function waitForXdm(getXdm = getXdmFromWindow, timeoutMs = POLL_TIMEOUT_MS) {
  return new Promise((resolve) => {
    pollForXdm(resolve, getXdm, timeoutMs);
  });
}

export function pollForXdm(callback, getXdm = getXdmFromWindow, timeoutMs = 10000) {
  const pollId = uuidv4();
  const pollIntervalMs = POLL_INTERVAL_MS;
  let pollTimeMs = 0;
  console.log(`Starting poll for XDM... (${pollId})`);
  const intervalId = setInterval(() => {
    console.log(`Polling for XDM... (${pollId})`);
    const xdm = getXdm();
    if (xdm) {
      console.log(`Found XDM (${pollId})`);
      clearInterval(intervalId);
      xdm.getContext((context) => {
        console.log(`Received context (${pollId})`, context);
        if (callback) {
          callback([xdm, context]);
        }
      });
    } else {
      pollTimeMs += pollIntervalMs;
      if (pollTimeMs > timeoutMs) {
        clearInterval(intervalId);
        throw new Error("Failed to find XDM within timeout");
      }
    }
  }, pollIntervalMs);
}

function getXdmFromWindow(name = "xdm") {
  return getWindow()[name];
}

export function closeXDM() {
  waitForXdm().then((results) => {
    const [xdm] = results;
    xdm?.current?.close();
  });
}
